import PropTypes from 'prop-types';

export const profile = PropTypes.shape({
  username: PropTypes.string,
  email: PropTypes.string,
  roles: PropTypes.array,
  company: PropTypes.number,
  groups: PropTypes.array
});